var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_vm._v("ViewAdmin")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }